import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=3ec824dc&scoped=true&"
import script from "./ArticlePage.vue?vue&type=script&lang=ts&"
export * from "./ArticlePage.vue?vue&type=script&lang=ts&"
import style0 from "./ArticlePage.vue?vue&type=style&index=0&id=3ec824dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec824dc",
  null
  
)

export default component.exports